/* eslint-disable react/prop-types */
import { Paper, Stack, Typography } from "@mui/material";

const MobileAffiliatedCards = ({ count, count_two, name }) => {
  return (
    <Stack direction="row"  justifyContent="space-between">
      <Typography
        variant="subtitle2"
        sx={{ fontSize: { xs: "13.59px", md: "14px" } }}
      >
        {name}
      </Typography>
      <Typography color="primary"   variant="subtitle2"
        sx={{ fontSize: { xs: "13.59px", md: "14px" } }}>
        {count}
      </Typography>
    </Stack>
  );
};

export default MobileAffiliatedCards;
